<div class="grid-x">
  <div class="cell small-12 description">
    The Send to Scanning side effect will generate a "Scan Documents" work item for the specified group.  It is imperative that the side effect has a defined run condition to determine when a task needs to be created for the group to receive documents.
  </div>
</div>
<div class="grid-x">
  <div class="cell small-6">
    Assign to:
  </div>
  <div class="cell small-6">
    @if (!(groupsLoading$ | async)) {
      <select [(ngModel)]="assignedGroup">
        @for (group of groupOptions; track group) {
          <option [value]="group.id" [selected]="assignedGroup === group.id">{{group.text}}</option>
        }
      </select>
    } @else {
      Loading groups...
    }
  </div>
</div>
<div class="grid-x">
  <div class="cell small-6">
    Documents to be received in
  </div>
  <div class="cell small-3">
    <input type="number" [(ngModel)]="timeFrame" />
  </div>
  <div class="cell small-3">
    days.
  </div>
</div>
<div class="grid-x">
  <div class="cell small-6">
    Application # Context:
  </div>
  <div class="cell small-6">
    <input type="text" [(ngModel)]="applicationNumberContext" />
  </div>
</div>
<div class="grid-x">
  <div class="cell small-12">
    Get Organization name from:
  </div>
  @for (opt of organizationOptions; track opt) {
    <div class="cell small-12">
      <input type="radio" name="organization" [(ngModel)]="organization" [value]="opt.id" /> {{opt.text}}
    </div>
  }
</div>
@if (organization === 'context') {
  <div class="grid-x">
    <div  class="cell small-6">
      Context Location:
    </div>
    <div class="cell small-6">
      <input type="text" [(ngModel)]="organizationContext" />
    </div>
  </div>
}



